import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { BlueWarningIcon } from 'Images';
import { useState } from 'react';
import { BubbleData } from './DataBubble';
import { useIsDesktop } from 'Hooks';

interface IPreviousConsideredPercent {
  previousConsideredPercent: string;
}

export const PreviousConsideredPercent = ({
  previousConsideredPercent,
}: IPreviousConsideredPercent) => {
  const [bubble, setBubble] = useState(false);

  const isDesktop = useIsDesktop();

  return (
    <Stack direction='row' gap={'8px'} width='auto'>
      <Stack position={'relative'} width={'auto'}>
        <Avatar
          alt={''}
          src={BlueWarningIcon}
          sx={{
            width: '17px',
            height: '17px',
            position: 'relative',
            top: '2px',
          }}
          onMouseOver={() => setBubble(true)}
          onMouseLeave={() => setBubble(false)}
        />
        {bubble && <BubbleData />}
      </Stack>
      <Stack gap={isDesktop ? '6px' : '3px'}>
        <Typography variant={'body6'} tabIndex={0}>
          {
            Dictionary[DICTIONARY.PersonalDetails].disabilityInformation
              .disabilityPercentPrevious
          }
        </Typography>
        <Typography variant={'body2'} tabIndex={0}>
          {Math.floor(Number(previousConsideredPercent)) + '%'}
        </Typography>
      </Stack>
    </Stack>
  );
};
